import { create } from "zustand";

const useAuthStore = create((set) => ({
  authToken: localStorage.getItem("authToken") || null,
  setAuthToken: (token) => {
    if (token) {
      localStorage.setItem("authToken", token);
    } else {
      localStorage.removeItem("authToken");
    }
    set({ authToken: token });
  },
  logout: () => {
    localStorage.removeItem("authToken");
    set({ authToken: null });
  },
  isAuthenticated: () => !!localStorage.getItem("authToken"),
}));

export default useAuthStore;
